import { useGetOrgUserProfile } from '@/services/auth'
import { useActiveOrgId } from './useActiveOrgId'

export const useActiveOrgProfile = () => {
  const { orgId: activeOrgId } = useActiveOrgId()
  return useGetOrgUserProfile(activeOrgId)
}
